(function (algolia) {
  'use strict';

  if (!algolia.config.autocomplete_enabled) return;

  const autocomplete = algolia.externals.autocomplete;
  const { config } = algolia;
  const getAlgoliaResults = algolia.externals.getAlgoliaResults;
  const redirectUrlPlugin = createRedirectUrlPlugin();
  algolia.searchClient.addAlgoliaAgent('Shopify Integration');

  // Retrieve the container from Shopify's config
  const containers = Array.from(document.querySelectorAll(algolia.config.input_selector));
  containers.forEach(container => {
    container.innerHTML = '';
    const containerClasses = container.classList;
    containerClasses.add('aa-MainContainer');
  });

  // Set plugins
  const { productsPlugin, collectionsPlugin, articlesPlugin, pagesPlugin, querySuggestionsPlugin } = algolia;
  const plugins = [
    redirectUrlPlugin,
    algolia.config.index_products && productsPlugin,
    algolia.config.index_collections && collectionsPlugin,
    algolia.config.index_articles && articlesPlugin,
    algolia.config.index_pages && pagesPlugin,
    algolia.config.autocomplete_query_suggestions && querySuggestionsPlugin
  ];

  const cssFile = document.getElementById('template_algolia_autocomplete.css');
  // Set CSS variables
  document.documentElement.style.setProperty(`--aa-text-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.secondary)}`);
  document.documentElement.style.setProperty(`--aa-primary-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.main)}`);
  document.documentElement.style.setProperty(`--aa-muted-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.muted)}`);
  document.documentElement.style.setProperty(`--aa-highlight-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.highlight)}`);
  // Link CSS
  algolia.appendStyle(cssFile.text);

  const autocompleteOptions = {
    openOnFocus: false,
    placeholder: 'Search Brands or Style',
    detachedMediaQuery: "(max-width: 1024px)",
    debug: algolia.config.autocomplete_debug,
    insights: algolia.config.analytics_enabled,
    plugins,
    render({ elements, render, html, state }, root) {
      if(state.query && state.query.length > 3) {
        const [querySuggestionsPluginResults] = state.collections.filter(({ source }) => source.sourceId === 'querySuggestionsPlugin');
        const displaySuggestions = algolia.config.autocomplete_query_suggestions && querySuggestionsPluginResults.items.length > 0;
        render(
          algolia.mainTemplate({ html, state }, elements, displaySuggestions),
          root
        );
      } else {
        render(html``, root);
      }
    },
    onSubmit({ state }) {
      window.location.href = `/search?q=${state.query}`;
    }
  };

  containers.forEach(container => {
    autocomplete({
      container,
      ...autocompleteOptions,
    });
  });

  // Add additional source for products with redirectUrlPlugin
  //autocompleteOptions.plugins.push(redirectUrlPlugin);

  // autocomplete({
  //   container: '.aa-MainContainer',
  //   ...autocompleteOptions,
  // });

  function focusAndOpenKeyboard(timeout) {
    if (!timeout) {
      timeout = 100;
    }
    // Align temp input element approx. to be where the input element is
    var __tempEl__ = document.createElement("input");
    __tempEl__.style.position = "absolute";
    __tempEl__.style.top = document.body.offsetTop + 7 + "px";
    __tempEl__.style.left = document.body.offsetLeft + "px";
    __tempEl__.style.height = 0;
    __tempEl__.style.opacity = 0;
    // Put this temp element as a child of the page <body> and focus on it
    document.body.appendChild(__tempEl__);
    __tempEl__.focus();

    // The keyboard is open. Now do a delayed focus on the target element
    setTimeout(function () {
      const els = document.querySelectorAll('.aa-Form input');
      const el = els[els.length - 1];
      el.focus();
      el.click();
      // Remove the temp element
      document.body.removeChild(__tempEl__);
    }, timeout);
  }

  $('.header__search-mobile .aa-Autocomplete .aa-DetachedSearchButton').on('click', function () {
    focusAndOpenKeyboard(1000);
  })
})(window.algoliaShopify);
